import API from "../../../api.js";
import {
  DOCTOR_APPOINTMENTS_REQUEST,
  DOCTOR_APPOINTMENTS_SUCCESS,
  DOCTOR_APPOINTMENTS_FAIL,
  PATIENT_HISTORY_REQUEST,
  PATIENT_HISTORY_SUCCESS,
  PATIENT_HISTORY_FAIL,
  PATIENT_HISTORY_CLEAR,
  MEDICINES_SEARCH_REQUEST,
  MEDICINES_SEARCH_SUCCESS,
  MEDICINES_SEARCH_FAIL,
  DOCTORS_LIST_REQUEST,
  DOCTORS_LIST_SUCCESS,
  DOCTORS_LIST_FAIL,
  MEDICAL_RECORD_CREATE_REQUEST,
  MEDICAL_RECORD_CREATE_SUCCESS,
  MEDICAL_RECORD_CREATE_FAIL,
  MEDICAL_RECORD_CREATE_RESET,
  MEDICAL_RECORD_GET_REQUEST,
  MEDICAL_RECORD_GET_SUCCESS,
  MEDICAL_RECORD_GET_FAIL,
  DOCTOR_STATS_REQUEST,
  DOCTOR_STATS_SUCCESS,
  DOCTOR_STATS_FAIL,
  PATIENT_APPOINTMENTS_SEARCH_REQUEST,
  PATIENT_APPOINTMENTS_SEARCH_SUCCESS,
  PATIENT_APPOINTMENTS_SEARCH_FAIL,
  MEDICAL_RECORD_UPDATE_REQUEST,  // ✅ ADD THIS
  MEDICAL_RECORD_UPDATE_SUCCESS,  // ✅ ADD THIS
  MEDICAL_RECORD_UPDATE_FAIL,
  //new
  DOCTOR_COMPLETED_APPOINTMENTS_REQUEST,
  DOCTOR_COMPLETED_APPOINTMENTS_SUCCESS,
  DOCTOR_COMPLETED_APPOINTMENTS_FAIL,
  DOCTOR_ALL_PENDING_REQUEST,
  DOCTOR_ALL_PENDING_SUCCESS,
  DOCTOR_ALL_PENDING_FAIL,
} from "../../constants/doctorConstants/doctorConstants.js";

/**
 * Get today's appointments for logged-in doctor
 * @param {string} searchMRCode - Optional MR-Code to search
 */
export const getDoctorAppointments = (searchMRCode = "") => async (dispatch) => {
  try {
    dispatch({ type: DOCTOR_APPOINTMENTS_REQUEST });
    
    // ✅ Add search parameter if provided
    const searchParam = searchMRCode ? `?search=${searchMRCode}` : "";
    const { data } = await API.get(`/doctor/appointments${searchParam}`);
    
    dispatch({ 
      type: DOCTOR_APPOINTMENTS_SUCCESS, 
      payload: data.appointments 
    });
  } catch (error) {
    dispatch({
      type: DOCTOR_APPOINTMENTS_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};

/**
 * Get complete patient medical history
 * @param {string} patientId - Patient's MongoDB ID
 */
export const getPatientHistory = (patientId) => async (dispatch) => {
  try {
    dispatch({ type: PATIENT_HISTORY_REQUEST });
    
    const { data } = await API.get(`/doctor/patient/${patientId}/history`);
    
    dispatch({ 
      type: PATIENT_HISTORY_SUCCESS, 
      payload: data 
    });
  } catch (error) {
    dispatch({
      type: PATIENT_HISTORY_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};

/**
 * Clear patient history from state
 */
export const clearPatientHistory = () => (dispatch) => {
  dispatch({ type: PATIENT_HISTORY_CLEAR });
};

/**
 * Search medicines for prescription
 * @param {string} query - Search query (medicine name or company)
 */
export const searchMedicines = (query) => async (dispatch) => {
  try {
    dispatch({ type: MEDICINES_SEARCH_REQUEST });
    
    const encodedQuery = encodeURIComponent(query);
    const url = `/doctor/medicines/search?q=${encodedQuery}`;
    
    console.log("Making request to:", url); // ✅ ADD THIS
    
    const { data } = await API.get(url);
    
    console.log("Received data:", data); // ✅ ADD THIS
    console.log("Medicines count:", data.medicines?.length); // ✅ ADD THIS
    
    dispatch({ 
      type: MEDICINES_SEARCH_SUCCESS, 
      payload: data.medicines || [] 
    });
    
    return data.medicines || [];
    
  } catch (error) {
    console.error("Medicine search error:", error); // ✅ ADD THIS
    console.error("Error response:", error.response?.data); // ✅ ADD THIS
    
    dispatch({
      type: MEDICINES_SEARCH_FAIL,
      payload: error.response?.data?.error || error.message,
    });
    return [];
  }
};
export const clearMedicinesSearch = () => (dispatch) => {
  dispatch({ type: MEDICINES_SEARCH_SUCCESS, payload: [] });
};

/**
 * Get all doctors for referral dropdown
 */
export const getDoctorsList = () => async (dispatch) => {
  try {
    dispatch({ type: DOCTORS_LIST_REQUEST });
    
    const { data } = await API.get("/doctor/doctors");
    
    dispatch({ 
      type: DOCTORS_LIST_SUCCESS, 
      payload: data.doctors 
    });
  } catch (error) {
    dispatch({
      type: DOCTORS_LIST_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};

/**
 * Create or update medical record with prescription
 * @param {Object} recordData - Medical record data
 * @returns {Promise} - Returns created medical record
 */
export const createMedicalRecord = (recordData) => async (dispatch) => {
  try {
    dispatch({ type: MEDICAL_RECORD_CREATE_REQUEST });
    console.log(recordData)
    const { data } = await API.post("/doctor/medical-record", recordData);
    
    dispatch({ 
      type: MEDICAL_RECORD_CREATE_SUCCESS, 
      payload: data.medicalRecord 
    });
    
    return data.medicalRecord;
  } catch (error) {
    dispatch({
      type: MEDICAL_RECORD_CREATE_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
    throw error;
  }
};

/**
 * Reset medical record creation state
 */
export const resetMedicalRecordCreate = () => (dispatch) => {
  dispatch({ type: MEDICAL_RECORD_CREATE_RESET });
};

/**
 * Get medical record by appointment ID (for continuing on-hold appointments)
 * @param {string} appointmentId - Appointment's MongoDB ID
 * @returns {Promise} - Returns medical record
 */
export const getMedicalRecordByAppointment = (appointmentId) => async (dispatch) => {
  try {
    dispatch({ type: MEDICAL_RECORD_GET_REQUEST });
    
    const { data } = await API.get(`/doctor/medical-record/${appointmentId}`);
    
    dispatch({ 
      type: MEDICAL_RECORD_GET_SUCCESS, 
      payload: data.medicalRecord 
    });
    
    return data.medicalRecord; // ✅ Return the record for use in component
  } catch (error) {
    dispatch({
      type: MEDICAL_RECORD_GET_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
    return null;
  }
};

/**
 * Mark prescription as printed
 * @param {string} recordId - Medical record's MongoDB ID
 */
export const markPrescriptionPrinted = (recordId) => async (dispatch) => {
  try {
    await API.put(`/doctor/medical-record/${recordId}/print`);
    // Optionally refresh appointments after marking as printed
    dispatch(getDoctorAppointments());
  } catch (error) {
    console.error("Mark printed error:", error);
  }
};

/**
 * Get doctor dashboard statistics
 */
export const getDoctorStats = () => async (dispatch) => {
  try {
    dispatch({ type: DOCTOR_STATS_REQUEST });
    
    const { data } = await API.get("/doctor/stats");
    
    dispatch({ 
      type: DOCTOR_STATS_SUCCESS, 
      payload: data 
    });
  } catch (error) {
    dispatch({
      type: DOCTOR_STATS_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};

/**
 * Search patient appointments for viewing/editing past records
 * @param {string} searchQuery - Patient name or MR code
 */
export const searchPatientAppointments = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: PATIENT_APPOINTMENTS_SEARCH_REQUEST });
    
    const encodedQuery = encodeURIComponent(searchQuery);
    const { data } = await API.get(`/doctor/appointments/search?q=${encodedQuery}`);
    
    dispatch({ 
      type: PATIENT_APPOINTMENTS_SEARCH_SUCCESS, 
      payload: data.appointments 
    });
    
    return data.appointments;
  } catch (error) {
    dispatch({
      type: PATIENT_APPOINTMENTS_SEARCH_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
    return [];
  }
};

/**
 * Update existing medical record
 * @param {string} recordId - Medical record ID
 * @param {Object} recordData - Updated medical record data
 */
export const updateMedicalRecord = (recordId, recordData) => async (dispatch) => {
  try {
    console.log("=== FRONTEND UPDATE DEBUG ===");
    console.log("Record ID:", recordId);
    console.log("Record Data:", JSON.stringify(recordData, null, 2));
    
    dispatch({ type: MEDICAL_RECORD_UPDATE_REQUEST });
    
    const { data } = await API.put(`/doctor/medical-record/${recordId}/update`, recordData);
    
    console.log("Update response:", data);
    
    dispatch({ 
      type: MEDICAL_RECORD_UPDATE_SUCCESS, 
      payload: data.medicalRecord 
    });
    
    return data.medicalRecord;
  } catch (error) {
    console.error("=== FRONTEND UPDATE ERROR ===");
    console.error("Error response:", error.response?.data);
    console.error("Error status:", error.response?.status);
    console.error("Error message:", error.message);
    
    dispatch({
      type: MEDICAL_RECORD_UPDATE_FAIL,
      payload: error.response?.data?.msg || error.response?.data?.error || error.message,
    });
    throw error;
  }
};
// Get completed appointments with history
export const getCompletedAppointments = (period = 'today', startDate = '', endDate = '') => async (dispatch) => {
  try {
    dispatch({ type: DOCTOR_COMPLETED_APPOINTMENTS_REQUEST });

    const params = new URLSearchParams({ period });
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    const { data } = await API.get(`/doctor/completed-appointments?${params}`);
    
    dispatch({
      type: DOCTOR_COMPLETED_APPOINTMENTS_SUCCESS,
      payload: data,
    });
    
    return data;
  } catch (error) {
    dispatch({
      type: DOCTOR_COMPLETED_APPOINTMENTS_FAIL,
      payload: error.response?.data?.error || error.message,
    });
  }
};

// Get all pending appointments (including backdated)
export const getAllPendingAppointments = () => async (dispatch) => {
  try {
    dispatch({ type: DOCTOR_ALL_PENDING_REQUEST });
    const { data } = await API.get('/doctor/all-pending-appointments');
    
    dispatch({
      type: DOCTOR_ALL_PENDING_SUCCESS,
      payload: data.appointments,
    });
  } catch (error) {
    dispatch({
      type: DOCTOR_ALL_PENDING_FAIL,
      payload: error.response?.data?.error || error.message,
    });
  }
}
